"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addQuestionNode = void 0;
const addQuestionNode = (parent, node, index = -1) => {
    if (!parent.subQuestions)
        parent.subQuestions = [];
    const child = Object.assign(Object.assign({}, node), { parentNodeId: parent.nodeId });
    if (index === -1)
        parent.subQuestions.push(child);
    else
        parent.subQuestions.splice(index, 0, child);
    return child;
};
exports.addQuestionNode = addQuestionNode;
exports.default = exports.addQuestionNode;
